export const isResumePersonalizationUiEnabled =
  process.env.NEXT_PUBLIC_RESUME_PERSONALIZATION_ENABLED === "true";

export const isAppcastResumeEligibilityEnabled =
  process.env.NEXT_PUBLIC_APPCAST_RESUME_ELIGIBILITY_ENABLED === "true";
